export default __webpack_public_path__ + "static/media/product03.92ce6aa5.jpg";